<div class="error-page">
  <cpc-error-page
    errorType="NotFound"
    [errorText]="errorText"
    (prevPage)="prevPage($event)">
  </cpc-error-page>
</div>
